import React, { createContext, useContext } from 'react';

export interface UsersSharedStateContextValue {
  userID: string;
  roles: string[];
}

const defaultValue: UsersSharedStateContextValue = {
  userID: '',
  roles: [],
};

const UsersSharedStateContext = createContext<UsersSharedStateContextValue>(defaultValue);

export const UsersSharedStateProvider: React.FC<{ value: UsersSharedStateContextValue; children: React.ReactNode }> = ({ value, children }) => {
  return (
    <UsersSharedStateContext.Provider value={value}>{children}</UsersSharedStateContext.Provider>
  );
};

export const useUsersSharedState = (): UsersSharedStateContextValue => useContext(UsersSharedStateContext);

